import { MdChat } from "react-icons/md";
import contactsService from "services/admin/contactsService";
import { formatNumber, useDashboardQuery } from "../dashboard-utils";
import KpiCard from "./KpiCard";

const ContactCounts = ({ month }: { month: number }) => {
  const q = useDashboardQuery(["contacts-count", month], async () => (await contactsService.getContactCounts({ month })).data?.count);

  return (
    <KpiCard
      icon={MdChat}
      accent="teal"
      label="Контакты"
      hint="Новые контакты за выбранный период"
      to="/admin/contacts"
      value={formatNumber(q.data)}
      loading={q.isLoading}
      fetching={q.isPlaceholderData}
      error={q.error}
      onRetry={q.refetch}
    />
  );
};

export default ContactCounts;
